import { api } from './api';

export function populateCredentialViewData(credentialID, callback) {


  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsPublicAssertionsRetrieve(...args),
    credentialID,
  )((err, data, response) => callback(response?.body || {}));

}
